export const get_stack = (e) => e.stack;